import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_CLINIC_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetClinicListPayload, GetClinicListResult } from '../types/getClinicList.type';

export const TAG_MEDREFILL_CLINIC_LIST = 'getClinicList';
export const getClinicList = <T extends BuilderType>(builder: T) =>
  builder.query<GetClinicListResult, GetClinicListPayload>({
    providesTags: [TAG_MEDREFILL_CLINIC_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_CLINIC_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetClinicListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
